// Libs
import React, { useState, useContext } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { StoresContext, Stores, StoresInstance } from "Globals/Stores";
import { Grid, Else, Show } from "@shoothill/core";
import styled from "styled-components";
import DashboardViewModel from "Globals/ViewModels/Dashboard/DashboardViewModel";
import { Link as RouterLink } from "react-router-dom";
import { Button, Drawer, Divider, List, Box, Typography, Paper, Link } from "@material-ui/core";
import { AppUrls } from "AppUrls";

// App
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
import { DashboardApplicationModel } from "Globals/Models/Domain/Dashboard/DashboardApplicationModel";
import { Applications } from "./Applications";
import { theme } from "Globals/Styles/AppTheme";

export const StyledStartNewApplicationButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 31px;
    background-color: ${theme.palette.hightownGreen.main};
    p {
        color: ${theme.palette.common.white};
    }
    :hover {
        background-color: ${theme.palette.hightownGreen.main};
    }
`;

export const DashboardView: React.FC = () => {
    const [paymentViewModel] = useState(() => new PaymentViewModel());
    const [viewModel] = useState(() => new DashboardViewModel());
    const domainStores = StoresInstance.Domain;

    const welcomeMessage = () => (
        <>
            <Typography color={"inherit"} variant={"h4"} style={{ fontWeight: "bold", marginBottom: "30px" }}>
                Welcome back,
            </Typography>
        </>
    );

    const renderApplications = () => (
        <>
            <Applications viewModel={viewModel} paymentViewModel={paymentViewModel} />
        </>
    );

    const startNewApplication = () => (
        <>
            <StyledStartNewApplicationButton variant={"contained"} onClick={viewModel.createNewApplication}>
                <Typography variant={"body1"}>Start new Shared Ownership Application Form</Typography>
            </StyledStartNewApplicationButton>
        </>
    );

    return useObserver(() => (
        <>
            <Box style={{ padding: "40px 35px" }}>
                {welcomeMessage()}
                {renderApplications()}
                <Divider style={{ borderTop: "1px solid" }} />
                {viewModel.model.canStartNewApplicationForm ? startNewApplication() : null}
            </Box>
        </>
    ));
};
